module.exports = __webpack_public_path__ + "img/process2.cf316b0f.png";